export default "__VITE_ASSET__2f19fb53__"